import httpService from "services/http";
import { refreshStreamAccessThunk, refreshTokenThunk } from "store/slices/auth/thunks";
import SessionStorageUtils from "utils/sessionStorage";

class TokenManager {
	static dispatch = null;
	static _instance = null;
	static EXPIRATION_PERIOD = 1500000; // milliseconds

	static get instance() {
		return TokenManager._instance || new TokenManager();
	}

	constructor() {
		if (TokenManager._instance) {
			return TokenManager._instance;
		}

		TokenManager._instance = this;

		this._pendingRequestsQueue = [];
		this.isTokenRefreshing = false;
	}

	async updateTokenAsync(isStream = false) {
		if (!TokenManager.dispatch) {
			return;
		}

		try {
			const { refreshToken } = SessionStorageUtils.get("player");

			this.isTokenRefreshing = true;
			const thunkFunction = isStream ? refreshStreamAccessThunk : refreshTokenThunk;
			const response = await TokenManager.dispatch(thunkFunction(refreshToken)).unwrap();

			this._pendingRequestsQueue.forEach((request) => {
				request.configs.headers.authorization = `Bearer ${response.token}`;

				httpService
					.defaultRequest(request.configs)
					.then((response) => request.resolve(response))
					.catch((error) => request.reject(error));
			});
		} catch (error) {
			console.error(error);
		} finally {
			this.isTokenRefreshing = false;
			this._pendingRequestsQueue = [];
		}
	}

	registerPendingRequest(configs) {
		const request = {
			configs
		};

		request.promise = new Promise((resolve, reject) => {
			request.resolve = resolve;
			request.reject = reject;
		});

		this._pendingRequestsQueue.push(request);

		return request.promise;
	}
}

export default TokenManager;
